<template>
    <div class="sa-list-component">
        <div class="sa-list-component-header">
            <b-form @submit.prevent="onSubmit">
                <b-row>
                    <b-col cols="12" md="4">
                        <label class="sa-label-data">Data Dal</label>
                        <date-picker v-model="filtro.dal" type="datetime" value-type="timestamp" format="DD-MM-YYYY HH:mm"></date-picker>
                    </b-col>
                    <b-col cols="12" md="4">
                        <label class="sa-label-data">Data Al</label>
                        <date-picker v-model="filtro.al" type="datetime" value-type="timestamp" format="DD-MM-YYYY HH:mm" :disabled-date="notBeforeDataDal"></date-picker>
                    </b-col>
                    <b-col cols="12" md="4">
                        <label class="sa-label-data">Tipo Misurazione</label>
                        <b-form-select v-model="filtro.misura" :options="misureOptions"></b-form-select>
                    </b-col>
                </b-row>
                <b-row class="sa-form-btn-filter">
                    <b-col class="sa-padding-right text-right">
                        <b-button type="submit" variant="info">{{ this.$i18n.t("patients.lblFind") }}</b-button>
                        <b-button type="button" variant="danger" @click="onReset">{{ this.$i18n.t("patients.lblResetFilter") }}</b-button>
                    </b-col>
                </b-row>
            </b-form>

            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>

        <div class="sa-list-component-body">
            <b-table sticky-header ref="table" stacked="lg" striped hover show-empty :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" sort-icon-left head-variant="light" class="sa-b-table" empty-text="Nessuna misurazione trovata">
                <template v-slot:cell(index)="row">
                    {{ (currentPage - 1) * perPage + row.index + 1 }}
                </template>
                <template v-slot:cell(measurename)="row">
                    {{ getMeasureLabel(row.item.measurename) }}
                </template>
                <template v-slot:cell(statoRange)="row">
                    {{ getStatoRange(row.item) }}
                </template>
            </b-table>
        </div>

        <div class="sa-list-component-footer">
            <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                <b-col lg="3">
                    <p>{{ this.$i18n.t("global.lblTotalRecords") }}: {{ rows }}</p>
                </b-col>
                <b-col lg="9">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    components: { DatePicker },
    mixins: [UtilityMixin],
    props: {
        idPaziente: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            pathResource: "/pazientemisure",
            pathResourceTipi: "/pazientemisuretipi",
            currentPage: 1,
            perPage: 25,
            filtro: {
                dal: new Date().getTime(),
                al: null,
                misura: null,
            },
            items: [],
            tipiMisurazione: [],
            fields: [
                { key: "index", label: "", sortable: false, thStyle: "width: 4rem" },
                { key: "measurename", label: "Tipo misurazione", sortable: true },
                { key: "value", label: "Valore", sortable: true, thStyle: "width: 10rem" },
                {
                    key: "istant",
                    label: "Data/Ora rilevazione",
                    sortable: true,
                    thStyle: "width: 15rem",
                    formatter: (value) => (value || value === 0 ? moment(new Date(value)).format("DD-MM-YYYY HH:mm:ss") : "---"),
                },
                { key: "idDevice", label: "Dispositivo", sortable: true, thStyle: "width: 13rem", formatter: (value) => value || "---" },
                { key: "statoRange", label: "Stato/Range", sortable: false, thStyle: "width: 13rem" },
            ],
        };
    },
    computed: {
        rows() {
            return this.items.length;
        },
        misureOptions() {
            const options = [{ value: null, text: "- Tutte -" }];
            this.tipiMisurazione.forEach((tipo) => {
                options.push({
                    value: tipo.misura,
                    text: this.getTipoLabel(tipo),
                });
            });
            return options;
        },
    },
    watch: {
        idPaziente: {
            immediate: true,
            handler(value) {
                if (value) {
                    this.loadData();
                } else {
                    this.items = [];
                }
            },
        },
    },
    mounted() {
        this.loadTipiMisurazione();
    },
    methods: {
        loadData() {
            if (!this.idPaziente) {
                return;
            }

            const params = {
                idPaziente: this.idPaziente,
                dal: this.formatDateTimeCustom(this.filtro.dal, "YYYY-MM-DD HH:mm:ss"),
                al: this.formatDateTimeCustom(this.filtro.al, "YYYY-MM-DD HH:mm:ss"),
                misura: this.filtro.misura,
            };

            this.$emit("loading", true);
            axios
                .get(process.env.VUE_APP_PATH_API + this.pathResource, { params })
                .then((response) => {
                    const data = response && response.data ? response.data.data : null;
                    this.items = Array.isArray(data) ? data.slice().sort((a, b) => this.getTimestamp(b.istant) - this.getTimestamp(a.istant)) : [];
                    this.currentPage = 1;
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                })
                .finally(() => {
                    this.$emit("loading", false);
                });
        },
        loadTipiMisurazione() {
            axios
                .get(process.env.VUE_APP_PATH_API + this.pathResourceTipi)
                .then((response) => {
                    const data = response && response.data ? response.data.data : null;
                    this.tipiMisurazione = Array.isArray(data) ? data : [];
                })
                .catch((error) => {
                    UtilityMixin.methods.messaggeBoxError(this, error);
                });
        },
        onSubmit() {
            if (this.filtro.dal && this.filtro.al && this.filtro.al < this.filtro.dal) {
                this.$bvModal.msgBoxOk("La data finale non può precedere la data iniziale.", {
                    title: "ATTENZIONE",
                    size: "sm",
                    centered: true,
                    okVariant: "outline-danger",
                    headerClass: "sa-msg-header-danger",
                });
                return;
            }
            this.loadData();
        },
        onReset() {
            this.filtro = { dal: new Date().getTime(), al: null, misura: null };
            this.loadData();
        },
        notBeforeDataDal(date) {
            return this.filtro.dal ? date < new Date(this.filtro.dal) : false;
        },
        getTimestamp(value) {
            const timestamp = new Date(value).getTime();
            return Number.isNaN(timestamp) ? 0 : timestamp;
        },
        getTipoLabel(tipo) {
            const label = tipo.descrizione || tipo.misura || "---";
            return this.getLabelTraduora(label);
        },
        getMeasureLabel(measureName) {
            const tipo = this.tipiMisurazione.find((item) => item.misura === measureName);
            return tipo ? this.getTipoLabel(tipo) : this.getLabelTraduora(measureName || "---");
        },
        getStatoRange(item) {
            if (item.isMistake === true || item.isMistake === 1 || item.isMistake === "true") {
                return "Errore";
            }
            return item.range || "---";
        },
    },
};
</script>
